import { useMemo } from 'react';

import type { BannerNotificationDto } from 'utils/api/dto';
import * as endpoints from 'utils/api/endpoints';
import { httpMethods, useFetchData } from 'utils/hooks/use-fetch-data';

import { selectLatestBanner } from '../components/notification-banner-utils';

export type UseFetchNotificationParams = {
    /** the environment: a banner of the other one is never chosen */
    staging: boolean;
};

/**
 * The banner to show: one object, so its text and its mask always come from the same banner (they were two states
 * before, set one by one and never cleared).
 */
export const useFetchNotification = ({ staging }: UseFetchNotificationParams) => {
    const { data } = useFetchData<BannerNotificationDto[]>({
        method: httpMethods.get,
        // A failure is logged by useFetchData; the page works without the banner
        url: endpoints.getLastBannerNotification
    });

    const banner = useMemo(() => (Array.isArray(data) ? selectLatestBanner(data, new Date(), staging) : undefined), [
        data,
        staging
    ]);

    const notification = banner?.description || null;
    const showMask = typeof banner?.showMask === 'number' ? banner.showMask : null;

    return { notification, showMask, isDisabled: !notification || showMask === null };
};
